if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', class ProductCarousel extends HTMLElement {
    constructor() {
      super();
      this.elements = this._getElements();
      this.posX1 = 0;
      this.posX2 = 0;
      this.posInitial;
      this.posFinal;
      this.threshold = 100;
      this.index = 0,
      this.allowShift = true;

      this.slidesLength = this.elements.slides.length;
      this.firstSlide = this.elements.slides[0];
      this.lastSlide = this.elements.slides[this.slidesLength - 1];
      this.cloneFirst = this.firstSlide.cloneNode(true);
      this.cloneLast = this.lastSlide.cloneNode(true);

      // Clone first and last slide
      this.elements.carouselItems.appendChild(this.cloneFirst);
      this.elements.carouselItems.insertBefore(this.cloneLast, this.firstSlide);

      this.elements.carouselItems.classList.remove('product-carousel-slides-hidden');
      this._setupEventListeners();
    }

    connectedCallback() {
      this.slideSize = this.querySelector('.product-carousel-wrapper').offsetWidth;
    }

    setSlideSize() {
      this.slideSize = this.querySelector('.product-carousel-wrapper').offsetWidth;
    }
    
    _getElements() {
      return {
        carouselItems: this.querySelector('.product-carousel-slides'),
        slides: this.querySelectorAll('.product-carousel-slide'),
        prev: this.querySelector('.product-carousel-prev'),
        next: this.querySelector('.product-carousel-next'),
      }
    }

    _setupEventListeners() {
        // Mouse events
      this.elements.carouselItems.onmousedown = this.dragStart.bind(this);
    
      this.elements.prev && this.elements.prev.addEventListener('click', () => { this.shiftSlide(-1) })
      this.elements.next && this.elements.next.addEventListener('click', () => { this.shiftSlide(1) })
      
      // Touch events
      this.elements.carouselItems.addEventListener('touchstart', this.dragStart.bind(this));
      this.elements.carouselItems.addEventListener('touchend', this.dragEnd.bind(this));
      this.elements.carouselItems.addEventListener('touchmove', this.dragAction.bind(this));
   
      
      // Transition events
      this.elements.carouselItems.addEventListener('transitionend', this.checkIndex.bind(this));
    }

    dragStart (e) {
      e = e || window.event;

      if(!(e.type === 'touchstart')) {
        e.preventDefault();
      }
      
      this.posInitial = this.elements.carouselItems.offsetLeft;

      if (e.type == 'touchstart') {
        this.posX1 = e.touches[0].clientX;
      } else {
        this.posX1 = e.clientX;
        document.onmouseup = this.dragEnd.bind(this);
        document.onmousemove = this.dragAction.bind(this);
      }
    }

    slideTo(slideIndex, smooth) {
      if(smooth) { 
        this.elements.carouselItems.classList.add('shifting');
        this.allowShift = false;
      }

      this.elements.carouselItems.style.left = -(slideIndex * this.slideSize) + "px";
      this.index = slideIndex - 1;
    }

    dragAction (e) {
      e = e || window.event;
      
      if (e.type == 'touchmove') {
        this.posX2 = this.posX1 - e.touches[0].clientX;
        this.posX1 = e.touches[0].clientX;
      } else {
        this.posX2 = this.posX1 - e.clientX;
        this.posX1 = e.clientX;
      }
      this.elements.carouselItems.style.left = (this.elements.carouselItems.offsetLeft - this.posX2) + "px";
    }
    
    dragEnd (e) {
      this.posFinal = this.elements.carouselItems.offsetLeft;
      if (this.posFinal - this.posInitial < -this.threshold) {
        this.shiftSlide(1, 'drag');
      } else if (this.posFinal - this.posInitial > this.threshold) {
        this.shiftSlide(-1, 'drag');
      } else {
        this.elements.carouselItems.style.left = (this.posInitial) + "px";
      }
  
      document.onmouseup = null;
      document.onmousemove = null;
    }

    shiftSlide(dir, action) {
      this.elements.carouselItems.classList.add('shifting');
      
      if (this.allowShift) {
        if (!action) { this.posInitial = this.elements.carouselItems.offsetLeft; }
  
        if (dir == 1) {
          this.elements.carouselItems.style.left = (this.posInitial - this.slideSize) + "px";
          this.index++;      
        } else if (dir == -1) {
          this.elements.carouselItems.style.left = (this.posInitial + this.slideSize) + "px";
          this.index--;      
        }
      };
      
      this.allowShift = false;

      let slideIndex = this.index + 1;

      if(this.index == -1) {
        slideIndex = this.slidesLength;
      }

      if(this.index == this.slidesLength) {
        slideIndex = 1;
      }
      
      let target = this;
      this.dispatchEvent(new CustomEvent('slideChanged', {
        bubbles: true,
        detail: {
          slideId: slideIndex,
          target: target,
        }
      }));
    }


    checkIndex () {
      this.elements.carouselItems.classList.remove('shifting');
  
      if (this.index == -1) {
        this.elements.carouselItems.style.left = -(this.slidesLength * this.slideSize) + "px";
        this.index = this.slidesLength - 1;
      }
  
      if (this.index == this.slidesLength) {
        this.elements.carouselItems.style.left = -(1 * this.slideSize) + "px";
        this.index = 0;
      }
      
      this.allowShift = true;
    }
  });
}

if(!customElements.get('product-carousel-modal-opener')) {
  customElements.define('product-carousel-modal-opener', class ProductCarouselModalOpener extends HTMLElement {
    constructor() {
      super();
      this._setupEventListeners();
    }

    _openModal() {
      const modal = document.querySelector(this.dataset.modal);
      const modalProductCarousel = modal.querySelector('product-carousel');
      const modalProductImagesThumbnails = modal.querySelector('product-images-thumbnails');
      if(Number(this.dataset.slideCount) > 1) {
        let currentSlideIndex = this.closest('product-carousel').index;
        modalProductCarousel.slideTo(currentSlideIndex + 1, false);
        modalProductImagesThumbnails.slideTo(currentSlideIndex + 1, false);
      }
      modal.show(this);
    }

    _setupEventListeners() {
      this.addEventListener('click', (event) => {
        this._openModal();
      });
    }
  })
}
